import "./cb.scss";
import m from "mithril";

let cb = () => {
	return {
		view: (v) => {
			// console.log("bool value", v.attrs.value);
			let checked =
				v.attrs.value === true || v.attrs.value == "True" || v.attrs.value == "true" || v.attrs.value == "1";

			return m(
				"label.prasora-block-checkbox-container",
				{
					class: v.attrs.disabled ? "non-editable" : "editable",
				},
				[
					m("input.checkbox", {
						disabled: v.attrs.disabled,
						type: "checkbox",
						checked: checked,
						onchange: v.attrs.onchange,
					}),
					// m("span.checkmark", null)
				]
			);
		},
	};
};

export default cb;
